import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastProvider } from './hooks/useToast';
import { SendJobsProvider } from './context/SendJobsContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import SendJobsFloater from './components/SendJobsFloater';
import Sidebar from './components/layout/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientProfile from './pages/ClientProfile';
import Podcasts from './pages/Podcasts';
import SendWeekly from './pages/SendWeekly';
import Settings from './pages/Settings';
import PodcastMatcher from './pages/PodcastMatcher';
import MasterList from './pages/MasterList';
import PitchGenerator from './pages/PitchGenerator';
import FormFilling from './pages/FormFilling';
import Leads from './pages/Leads';

function AppShell() {
  const auth = useAuth();
  if (auth.loading) return null;
  if (auth.loginRequired && !auth.authenticated) return <Login />;

  return (
    <SendJobsProvider>
      <BrowserRouter>
        <div className="app-layout">
          <Sidebar />
          <div className="main-content">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientProfile />} />
              <Route path="/podcasts" element={<Podcasts />} />
              <Route path="/send" element={<SendWeekly />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/podcast-matcher" element={<PodcastMatcher />} />
              <Route path="/master-list" element={<MasterList />} />
              <Route path="/pitch-generator" element={<PitchGenerator />} />
              <Route path="/form-filling" element={<FormFilling />} />
              <Route path="/leads" element={<Leads />} />
            </Routes>
          </div>
        </div>
        <SendJobsFloater />
      </BrowserRouter>
    </SendJobsProvider>
  );
}

export default function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    </ToastProvider>
  );
}
